import React from 'react';
import { Button } from '@upperhand/playmaker';

import 'App.css';

const FullPageError = () => (
  <div className="error">
    <div className="error__text">
      An error has occurred. If the problem persists, restart the app or
      contact&nbsp;
      <a href="mailto:support@getupperhand.com">support@getupperhand.com</a>.
    </div>
    <div className="error__btn">
      <Button
        textTransform="uppercase"
        // Do not remove function wrapper for onClick. https://stackoverflow.com/q/10839989
        onClick={() => window.location.reload()}
      >
        Try again
      </Button>
    </div>
  </div>
);

export default FullPageError;
